var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 268,
    height: 250,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h205v15H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 268,
    height: 260,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1396",
    transform: "translate(-700 -3654)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(700 3654)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 8",
    fill: "#f2f3f4",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 14h228a8 8 0 0 1 8 8v228H12V22a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14.5h228a7.5 7.5 0 0 1 7.5 7.5v227.5h-243V22a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 9",
    fill: "#f7f7f7",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720 3668h228a8 8 0 0 1 8 8v16H712v-16a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 3668.5h228a7.5 7.5 0 0 1 7.5 7.5v15.5h-243V3676a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(722 3677)",
    fill: "#ff5552"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 6",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(730 3677)",
    fill: "#ffb53d"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 7",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(738 3677)",
    fill: "#00c243"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 10",
    fill: "#fff",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M712 3691h244v20H712z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M712.5 3691.5h243v19h-243z"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 8",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(722 3696)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(882 3699)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(898 3699)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(914 3699)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(930 3699)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1392"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 169",
    d: "M814.527 3871h38.949c2.017 0 3.651 1.343 3.651 3v10c0 1.657-1.635 3-3.651 3h-38.949c-2.016 0-3.651-1.343-3.651-3v-10c0-1.657 1.635-3 3.651-3Z",
    fill: "#fd0826"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 184",
    d: "M819.484 3876.288h2.728a2.116 2.116 0 0 1 1.416.412 1.422 1.422 0 0 1 .472 1.136 1.659 1.659 0 0 1-.12.676 1.476 1.476 0 0 1-.28.432 1.094 1.094 0 0 1-.316.236q-.156.072-.228.1v.016a1.02 1.02 0 0 1 .276.08.814.814 0 0 1 .276.2 1.111 1.111 0 0 1 .212.364 1.609 1.609 0 0 1 .084.56 5.068 5.068 0 0 0 .072.912 1.205 1.205 0 0 0 .24.588h-1.072a.933.933 0 0 1-.132-.408q-.02-.224-.02-.432a4.118 4.118 0 0 0-.048-.676 1.179 1.179 0 0 0-.176-.472.745.745 0 0 0-.348-.276 1.536 1.536 0 0 0-.564-.088h-1.472V3882h-1Zm1 2.6h1.64a1.041 1.041 0 0 0 .728-.228.884.884 0 0 0 .248-.684 1.058 1.058 0 0 0-.08-.444.647.647 0 0 0-.22-.268.809.809 0 0 0-.32-.128 2.122 2.122 0 0 0-.372-.036h-1.624Zm7.376.68a1.471 1.471 0 0 0-.092-.416 1.108 1.108 0 0 0-.208-.352 1.03 1.03 0 0 0-.32-.24.943.943 0 0 0-.42-.092 1.1 1.1 0 0 0-.436.084 1 1 0 0 0-.336.232 1.147 1.147 0 0 0-.224.348 1.214 1.214 0 0 0-.092.432Zm-2.128.6a1.588 1.588 0 0 0 .068.464 1.143 1.143 0 0 0 .2.392.983.983 0 0 0 .344.268 1.135 1.135 0 0 0 .5.1 1.1 1.1 0 0 0 .644-.172 1.017 1.017 0 0 0 .364-.52h.864a1.72 1.72 0 0 1-.248.6 1.726 1.726 0 0 1-.424.444 1.83 1.83 0 0 1-.556.276 2.238 2.238 0 0 1-.644.092 2.19 2.19 0 0 1-.868-.16 1.786 1.786 0 0 1-.632-.452 1.9 1.9 0 0 1-.392-.688 2.8 2.8 0 0 1-.132-.88 2.49 2.49 0 0 1 .14-.836 2.14 2.14 0 0 1 .4-.7 1.913 1.913 0 0 1 .628-.476 1.9 1.9 0 0 1 .832-.176 1.854 1.854 0 0 1 .876.2 1.922 1.922 0 0 1 .644.54 2.186 2.186 0 0 1 .372.772 2.366 2.366 0 0 1 .06.9Zm7.592 1.616a1.76 1.76 0 0 1-.524 1.4 2.217 2.217 0 0 1-1.508.46 3.157 3.157 0 0 1-.628-.064 1.866 1.866 0 0 1-.576-.216 1.389 1.389 0 0 1-.436-.4 1.216 1.216 0 0 1-.208-.608h.912a.73.73 0 0 0 .136.312.7.7 0 0 0 .228.188.867.867 0 0 0 .292.088 2.71 2.71 0 0 0 .336.02 1.064 1.064 0 0 0 .808-.276 1.1 1.1 0 0 0 .256-.788v-.628h-.016a1.387 1.387 0 0 1-.52.536 1.406 1.406 0 0 1-.72.192 1.89 1.89 0 0 1-.844-.172 1.606 1.606 0 0 1-.576-.472 1.961 1.961 0 0 1-.332-.692 3.265 3.265 0 0 1-.1-.84 2.441 2.441 0 0 1 .128-.792 2.019 2.019 0 0 1 .368-.66 1.763 1.763 0 0 1 .588-.452 1.79 1.79 0 0 1 .788-.168 1.587 1.587 0 0 1 .72.164 1.113 1.113 0 0 1 .5.516h.016v-.568h.912Zm-2.024-.5a1.006 1.006 0 0 0 .516-.124 1.013 1.013 0 0 0 .344-.328 1.444 1.444 0 0 0 .192-.464 2.323 2.323 0 0 0 .06-.524 2.041 2.041 0 0 0-.064-.512 1.376 1.376 0 0 0-.2-.44.947.947 0 0 0-.344-.3 1.074 1.074 0 0 0-.508-.112.96.96 0 0 0-.512.128 1.025 1.025 0 0 0-.336.332 1.433 1.433 0 0 0-.184.464 2.445 2.445 0 0 0-.056.516 1.963 1.963 0 0 0 .064.5 1.381 1.381 0 0 0 .2.436 1.046 1.046 0 0 0 .336.312.954.954 0 0 0 .492.112Zm3-4.992h.912v.864h-.912Zm0 1.576h.912V3882h-.912Zm2.624 2.808a.687.687 0 0 0 .3.56 1.2 1.2 0 0 0 .632.16 2.441 2.441 0 0 0 .292-.02 1.271 1.271 0 0 0 .312-.076.579.579 0 0 0 .236-.164.394.394 0 0 0 .084-.284.4.4 0 0 0-.128-.288.887.887 0 0 0-.308-.18 2.984 2.984 0 0 0-.428-.116q-.24-.048-.488-.1a4.58 4.58 0 0 1-.492-.136 1.588 1.588 0 0 1-.424-.216 1 1 0 0 1-.3-.348 1.112 1.112 0 0 1-.112-.524.941.941 0 0 1 .164-.564 1.257 1.257 0 0 1 .412-.38 1.811 1.811 0 0 1 .56-.2 3.29 3.29 0 0 1 .588-.056 2.691 2.691 0 0 1 .612.068 1.663 1.663 0 0 1 .528.22 1.292 1.292 0 0 1 .392.4 1.371 1.371 0 0 1 .2.588h-.952a.568.568 0 0 0-.3-.44 1.245 1.245 0 0 0-.54-.112 1.932 1.932 0 0 0-.228.016 1.054 1.054 0 0 0-.248.06.522.522 0 0 0-.2.128.306.306 0 0 0-.08.22.348.348 0 0 0 .116.272.918.918 0 0 0 .3.172 2.984 2.984 0 0 0 .428.116l.5.1q.26.052.488.136a1.574 1.574 0 0 1 .428.216 1.05 1.05 0 0 1 .3.344 1.038 1.038 0 0 1 .116.512 1.113 1.113 0 0 1-.168.624 1.328 1.328 0 0 1-.436.416 1.983 1.983 0 0 1-.6.232 3.016 3.016 0 0 1-.648.072 2.82 2.82 0 0 1-.724-.088 1.688 1.688 0 0 1-.576-.268 1.3 1.3 0 0 1-.384-.448 1.425 1.425 0 0 1-.148-.636Zm3.08-2.808h.688v-1.24h.912v1.24h.824v.68h-.824v2.208a2.2 2.2 0 0 0 .012.244.428.428 0 0 0 .056.176.268.268 0 0 0 .132.108.649.649 0 0 0 .24.036h.192a.954.954 0 0 0 .192-.028v.7l-.3.032a2.679 2.679 0 0 1-.3.016 2.019 2.019 0 0 1-.58-.068.774.774 0 0 1-.344-.2.69.69 0 0 1-.168-.332 2.5 2.5 0 0 1-.052-.456v-2.44h-.688Zm5.952 1.7a1.471 1.471 0 0 0-.092-.416 1.108 1.108 0 0 0-.208-.352 1.03 1.03 0 0 0-.32-.24.943.943 0 0 0-.42-.092 1.1 1.1 0 0 0-.436.084 1 1 0 0 0-.336.232 1.147 1.147 0 0 0-.224.348 1.214 1.214 0 0 0-.092.432Zm-2.128.6a1.588 1.588 0 0 0 .068.464 1.143 1.143 0 0 0 .2.392.983.983 0 0 0 .344.268 1.135 1.135 0 0 0 .5.1 1.1 1.1 0 0 0 .644-.172 1.017 1.017 0 0 0 .364-.516h.864a1.72 1.72 0 0 1-.248.6 1.726 1.726 0 0 1-.424.444 1.83 1.83 0 0 1-.556.272 2.238 2.238 0 0 1-.644.092 2.19 2.19 0 0 1-.864-.16 1.786 1.786 0 0 1-.636-.452 1.9 1.9 0 0 1-.392-.688 2.8 2.8 0 0 1-.132-.88 2.49 2.49 0 0 1 .14-.836 2.14 2.14 0 0 1 .4-.7 1.913 1.913 0 0 1 .628-.476 1.9 1.9 0 0 1 .832-.176 1.854 1.854 0 0 1 .876.2 1.922 1.922 0 0 1 .644.54 2.186 2.186 0 0 1 .372.772 2.366 2.366 0 0 1 .06.9Zm3.768-2.3h.856v.8h.016a.923.923 0 0 1 .156-.328 1.521 1.521 0 0 1 .28-.292 1.415 1.415 0 0 1 .364-.212 1.09 1.09 0 0 1 .408-.08 1.979 1.979 0 0 1 .22.008l.124.016v.88q-.1-.016-.2-.028a1.644 1.644 0 0 0-.2-.012 1.048 1.048 0 0 0-.436.092 1 1 0 0 0-.356.272 1.333 1.333 0 0 0-.24.444 1.922 1.922 0 0 0-.088.608V3882h-.904Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1611",
    fill: "#c7cbd1",
    d: "M712 3711h244v78H712z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1612",
    width: 87,
    height: 9,
    rx: 1,
    transform: "translate(733 3770)",
    fill: "#a6acb6"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1393",
    transform: "translate(381 1514)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1507",
    width: 190,
    height: 4,
    rx: 1,
    transform: "translate(358 2314)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1509",
    width: 190,
    height: 4,
    rx: 1,
    transform: "translate(358 2323)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1510",
    width: 186,
    height: 4,
    rx: 1,
    transform: "translate(358 2332)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1615",
    width: 132,
    height: 4,
    rx: 1,
    transform: "translate(358 2341)",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1613",
    fill: "#fff",
    d: "M712 3789h244v26H712z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 26",
    transform: "translate(732 3794)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1394",
    transform: "translate(-731 -3794)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 22",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(741 3794)",
    fill: "#a6acb6"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1614",
    width: 27,
    height: 4,
    rx: 1,
    transform: "translate(731 3805)",
    fill: "#c0c5cb",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1394",
    transform: "translate(-687 -3794)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 22",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(741 3794)",
    fill: "#a6acb6"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1614",
    width: 27,
    height: 4,
    rx: 1,
    transform: "translate(731 3805)",
    fill: "#c0c5cb",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1394",
    transform: "translate(-643 -3794)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 22",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(741 3794)",
    fill: "#a6acb6"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1614",
    width: 27,
    height: 4,
    rx: 1,
    transform: "translate(731 3805)",
    fill: "#c0c5cb",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1394",
    transform: "translate(-599 -3794)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 22",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(741 3794)",
    fill: "#a6acb6"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1614",
    width: 27,
    height: 4,
    rx: 1,
    transform: "translate(731 3805)",
    fill: "#c0c5cb",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1394",
    transform: "translate(-555 -3794)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 22",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(741 3794)",
    fill: "#a6acb6"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1614",
    width: 27,
    height: 4,
    rx: 1,
    transform: "translate(731 3805)",
    fill: "#c0c5cb",
    opacity: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1395",
    fill: "none",
    stroke: "#f2f2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 180",
    d: "M928.771 3771.829h-1.924a.824.824 0 0 0-.824.824v1.649a.824.824 0 0 0 .824.824h1.924l3.378 3.377a.275.275 0 0 0 .469-.194v-9.663a.275.275 0 0 0-.469-.194Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 181",
    d: "M935.364 3770.181a4.14 4.14 0 0 1 0 6.594"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 182",
    d: "M934.265 3771.555a2.229 2.229 0 0 1 0 3.846"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.8c31c0ec9210dd50b3add22e0dafebfe.svg";
export { ForwardRef as ReactComponent };